import { useState } from "react";
import PropTypes from 'prop-types';
import { Button } from "../Button/Button";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = "#kof-steps .position {\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n#kof-steps .navigation button {\n  margin-right: 8px;\n  margin-bottom: 8px;\n}";
  const fileName = "Steps_Steps_ab8b1f21-8cec-4042-a899-10f85bb99591";
  const element = document.querySelector("style[data-sass-component='Steps_Steps_ab8b1f21-8cec-4042-a899-10f85bb99591']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const defaultTranslations = {
  'steps.step': 'Step',
  'steps.next': 'Next step',
  'steps.previous': 'Previous step'
};
function Steps(props) {
  const [currentStep, setCurrentStep] = useState(1);
  const currentStepIndex = currentStep - 1;
  const stepContent = props.items[currentStepIndex];
  const isFirstStep = currentStep === 1;
  const isLastStep = props.items.length === currentStep;
  const translate = key => props.translate ? props.translate(key) : defaultTranslations[key];
  return /*#__PURE__*/_jsxs("div", {
    id: 'kof-steps',
    children: [/*#__PURE__*/_jsxs("p", {
      className: 'position',
      children: [translate('steps.step'), " ", currentStep, "/", props.items.length]
    }), /*#__PURE__*/_jsxs("div", {
      className: 'navigation',
      children: [!isFirstStep && /*#__PURE__*/_jsx(Button, {
        className: 'previous',
        type: "secondary",
        onClick: () => setCurrentStep(currentStep - 1),
        children: translate('steps.previous')
      }), !isLastStep && /*#__PURE__*/_jsx(Button, {
        className: 'next',
        type: "secondary",
        onClick: () => setCurrentStep(currentStep + 1),
        children: translate('steps.next')
      })]
    }), stepContent]
  });
}
Steps.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  translate: PropTypes.func
};
export { Steps };